import { useContext } from 'react';
import { StoreContext } from '../../store';
import { ReactComponent as Logo } from '../../assets/walkspan-logo-2.svg';

const ExploreThankYou = () => {
  const { navigate } = useContext(StoreContext);
  return (
    <div className="w-full h-full bg-white text-black flex flex-col items-center justify-center text-center p-4 text-xl">
      <Logo />
      <h1>Thank You for Exploring!</h1>
      <p>This search tool works better when you're signed in</p>
      <div
        className='bg-[#fe572a] text-white flex justify-center items-center px-4 py-2 cursor-pointer mt-4 w-[280px] hover:bg-[#e04c24] transition-colors duration-300'
        onClick={() => navigate('/login')}
      >
        Sign in
      </div>
    </div>
  );
};

export default ExploreThankYou;